import { ROUTES } from "../constants/routes";

/**
 * Navigation utilities for user-related pages
 *
 * Example usage:
 * ```tsx
 * import { userNavigation } from '../utils/navigation';
 *
 * // Navigate to a user profile
 * navigate(userNavigation.getUserProfileUrl('user123'));
 *
 * // Navigate to user directory with filters
 * navigate(userNavigation.getUserDirectoryUrl({ discipline: 'engineering' }));
 * ```
 */
export const userNavigation = {
  /**
   * Get the URL for a user profile page
   * @param userId - The ID of the user
   * @returns The URL path for the user profile
   */
  getUserProfileUrl: (userId: string): string => {
    return `${ROUTES.USER_DIRECTORY}/${userId}`;
  },

  /**
   * Get the URL for user directory with optional filters
   * @param filters - Optional filters for user directory
   * @returns The URL path for the user directory
   */
  getUserDirectoryUrl: (filters?: {
    discipline?: string;
    industry?: string;
  }): string => {
    const searchParams = new URLSearchParams();
    if (filters?.discipline)
      searchParams.append("discipline", filters.discipline);
    if (filters?.industry) searchParams.append("industry", filters.industry);

    const queryString = searchParams.toString();
    return queryString
      ? `${ROUTES.USER_DIRECTORY}?${queryString}`
      : ROUTES.USER_DIRECTORY;
  },

  /**
   * Get the URL for a recipe page (placeholder for when recipe pages are implemented)
   * @param recipeId - The ID of the recipe
   * @returns The URL path for the recipe
   */
  getRecipeUrl: (recipeId: string): string => {
    return `${ROUTES.RECIPE_DETAIL}/${recipeId}`;
  },
};
